module.exports = __webpack_public_path__ + "img/neudorf-wine.5dc7fdb5.webp";